import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemsHostDirective } from './items-host/items-host.directive';
import { NoRightClickDirective } from './no-right-click/no-right-click.directive';

@NgModule({

  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
